import React from 'react';
import {
  DateRangeDropdownV2,
  FormFieldV2 as FormField,
  type SearchFieldRef,
  SearchFieldV2 as SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, checkboxColumn } from '@/constants/search-columns';

import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';

interface BasicInfoProps {
  searchFieldStates: {
    account: TaiKhoan[];
    setAccount: React.Dispatch<React.SetStateAction<TaiKhoan[]>>;
  };
  accountRef?: React.RefObject<SearchFieldRef<TaiKhoan> | null>;
}

const ALLOWED_DEBT_ACCOUNT_CODE_PREFIXES = ['131', '138', '141', '244', '331', '338'];

const BasicInfo: React.FC<BasicInfoProps> = ({ searchFieldStates, accountRef }) => {
  const handleCellValueChange = (rowData: TaiKhoan, field: string, newValue: TaiKhoan) => {
    if (field === 'selected') {
      const invoiceUuid = rowData.uuid;
      if (newValue) {
        searchFieldStates.setAccount((prev: TaiKhoan[] | null) => {
          const prevArray = Array.isArray(prev) ? prev : [];
          return [...prevArray, rowData];
        });
      } else {
        searchFieldStates.setAccount((prev: TaiKhoan[] | null) => {
          const prevArray = Array.isArray(prev) ? prev : [];
          return prevArray.filter((invoice: TaiKhoan) => invoice.uuid !== invoiceUuid);
        });
      }
    }
  };

  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Từ ngày/Đến ngày:</Label>
          <div>
            <DateRangeDropdownV2
              fromDateName='ngay_ct1'
              toDateName='ngay_ct2'
              toFieldClassName='w-48'
              fromFieldClassName='w-48'
            />
          </div>
        </div>

        <div className='flex items-start'>
          <Label className='w-40 min-w-40 pt-2'>Tài khoản:</Label>
          <SearchField<TaiKhoan>
            ref={accountRef}
            multiple
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/filter_by_code/?tk=${ALLOWED_DEBT_ACCOUNT_CODE_PREFIXES}`}
            searchColumns={[
              ...checkboxColumn(handleCellValueChange, searchFieldStates.account),
              ...accountSearchColumns
            ]}
            columnDisplay='code'
            displayRelatedField='name'
            dialogTitle='Danh mục tài khoản công nợ'
            value={searchFieldStates.account}
            onRowSelection={searchFieldStates.setAccount}
            className='w-48'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Kiểu xem:</Label>
          <FormField
            name='kieu_xem'
            type='select'
            options={[
              { value: 1, label: 'Nhóm theo tài khoản tổng hợp' },
              {
                value: 2,
                label: 'Chi tiết theo tài khoản hạch toán'
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
